module.exports = __webpack_public_path__ + "static/img/partner-3cems.6e3aad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-3cems.png
// module id = +4U6
// module chunks = 34